<template>
    <div class="w-100">

        <img src="/img/logo_icon.svg" style="height: 35px;" class="mb-4" />

        <loading v-if="loading"></loading>
        <div v-else>
            <div v-if="displayFinish" class="text-center">
                <img src="/img/celebration.gif" style="border-radius: 16px; margin-bottom: 1.5em; width: 100%;" />

                <h1 class="my-3">Account created</h1>

                <p class="text-left mx-auto p-3" style="max-width: 500px; border-radius: 16px; background-color: #f2f4f7;">
                    <b>Portal URL</b><br /><span class="text-primary">{{portal_url}}</span><br /><br />
                    ✍️  Remember the portal URL. You can only log in here.
                </p>
                <a class="btn btn-primary btn-block mt-3" :href="hash_login_url">Go to your portal</a>
            </div>



            <div v-if="isFormOpen">

                <div v-if="step === 1">
                    <h1 class="mt-0 mb-3">Welcome to ProductLift 👋 </h1>

                    <p class="mb-5">Let's build your product feedback and roadmap hub.</p>

                    <validation-observer ref="observer" v-slot="{ passes }" :lazy="true">
                        <form @submit.stop.prevent="passes(goToStep2)">

                            <p class="mt-5 mb-1">Product or company name</p>
                            <validation-provider name="name" rules="min:3|required" v-slot="{ errors }">
                                <b-form-input v-model="name" placeholder="E.g. Spotify app" @input="generateDomain">></b-form-input>
                                <span class="validation">{{ errors[0] }}</span>
                            </validation-provider>

                            <button type="submit" class="btn btn-primary btn-block mt-3" id="complete_step_one">Next step</button>
                            <p class="small mt-5">Already have an account? <a href="https://app.productlift.dev/find_portal">Login to your account</a></p>
                        </form>
                    </validation-observer>
                </div>
                <div v-if="step === 2">
                    <p class="mb-3">Finish these settings to complete your account.</p>

                    <validation-observer ref="observer_2" v-slot="{ passes }" :lazy="true">
                        <form @submit.stop.prevent="passes(signup)">

<!--                            <p class="mt-3 mb-1">Portal URL</p>-->
<!--                            <validation-provider name="domain" rules="subdomain|required" v-slot="{ errors }">-->
<!--                                <b-input-group append=".productlift.dev">-->
<!--                                    <b-form-input v-model="domain" placeholder="my-product"></b-form-input>-->
<!--                                </b-input-group>-->
<!--                                <span class="validation">{{ errors[0] }}</span>-->
<!--                            </validation-provider>-->
<!--                            <small class="text-muted">Start with a .productlift.dev domain, switch to custom after signup.</small>-->
                            <p class="mt-3 mb-1">Email</p>
                            <validation-provider name="email" rules="email|required" v-slot="{ errors }">
                                <b-form-input type="email" autocomplete="email" v-model="email" placeholder="Enter your email"></b-form-input>
                                <span class="validation">{{ errors[0] }}</span>
                            </validation-provider>

                            <p class="mt-3 mb-1">Password</p>
                            <validation-provider name="password" rules="required" v-slot="{ errors }">
                                <b-form-input type="password" autocomplete="new-password" v-model="password" placeholder="••••••••••"></b-form-input>
                                <span class="validation">{{ errors[0] }}</span>
                            </validation-provider>

                            <p class="mt-3 mb-1">Language</p>
                            <validation-provider name="language" rules="required" v-slot="{ errors }">
                                <b-form-select v-model="language" :options="language_options"></b-form-select>
                                <span class="validation">{{ errors[0] }}</span>
                            </validation-provider>
                            <small class="text-muted">Language missing? Tell us post-signup—we’ll add it!</small>

                            <p class="text-muted">By signing up you agree with the <a href="https://www.productlift.dev/legal" target="_blank" style="color: #000000; text-decoration: underline;">Terms</a>.</p>
<!--                            <validation-provider name="terms" rules="required" v-slot="{ errors }">-->
<!--                                <b-form-checkbox class="mt-5" v-model="checkbox" value="accepted" :unchecked-value="null"> <span class="font-weight-normal small">I agree with the <a href="https://www.productlift.dev/legal" target="_blank" style="color: #000000; text-decoration: underline;">Terms</a>.</span></b-form-checkbox>-->
<!--                                <span class="validation">{{ errors[0] }}</span>-->
<!--                            </validation-provider>-->

                            <button type="submit" class="btn btn-primary btn-block mt-3" id="finish_signup">Start free trial</button>
                        </form>
                    </validation-observer>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import NotificationPop from '../mixins/NotificationPop.js'
import Loading
    from "./Loading";
import {
    mapState
} from "vuex";

export default {
    name: "Signup",
    mixins: [NotificationPop],
    components: {
        Loading
    },

    data() {
        return {
            loading: true,
            isFormOpen: true,
            progress: 20,
            language_options: [],
            hash_login_url: null,
            portal_url: null,
            displayFinish: false,
            step: 1,


            email: null,
            language: 'en',
            password: null,
            checkbox: null,
            domain: null,
            name: null,
            visitor_id: null,

            loadingTexts: [
                "Rounding up feature requests...",
                "Calibrating the feedback loop...",
                "Whispering sweet nothings to the code...",
                "Brewing coffee for the dev team...",
                "Sorting feedback...",
                "Chasing bugs around the office...",
                "Sketching the next big thing...",
                "Polishing pixels...",
                "Deciphering developer notes...",
                "Launching new ideas..."
            ],
            currentTextIndex: 0
        }
    },

    async created() {
        if(this.environment === 'local') {
            this.email = 'ruben@99c.nl'
            this.password = 'password'
            this.checkbox = true
            this.name = 'Demo'
            this.generateDomain()
        }

        this.$http.get('/api/available_languages')
            .then(({data}) => {
                this.loading = false;
                this.language_options = data
            })
            .catch(error => {
                this.loading = false;
                this.popNotification('Something went wrong on our side. Could not load buttons. Please try again or contact support@productlift.dev', 'danger')
            });

        // Get 'visitor_id' from URL query parameter
        const urlParams = new URLSearchParams(window.location.search);
        this.visitor_id = urlParams.get('vid');
    },
    computed: {
        nameSlug() {
            return this.slugify(this.name);
        },
        currentLoadingText() {
            return this.loadingTexts[this.currentTextIndex];
        },
        // Get portal settings from master.blade.php
        ...mapState(['environment']),
    },
    methods: {
        startLoadingTexts() {
            const intervalId = setInterval(() => {
                if (this.currentTextIndex < this.loadingTexts.length - 1) {
                    this.currentTextIndex++;
                } else {
                    clearInterval(intervalId); // Stop changing texts after the last one
                }
            }, 1500); // Change text every second
        },
        beforeDestroy() {
            if (intervalId) {
                clearInterval(intervalId);
            }
        },
        /**
         * Show finish
         */
        gotoFinish: function () {
            this.displayFinish = true

            this.$confetti.start({
                particles: [
                    {
                        type: 'heart',
                        size: 14,
                    }
                ],
            });
            setTimeout(() => this.$confetti.stop(), 2000);
        },

        /**
         * Create the new portal
         */
        goToStep2: function () {
            this.loading = true;

            let app = this
            setTimeout(() => {
                app.step = 2;
                this.loading = false;
            }, 750);
        },
        signup: function () {
            this.isFormOpen = false;
            this.loading = true;
            this.license_error = null; // reset
            this.startLoadingTexts();

            this.$http.post('/api/signup',{
                name: this.name,
                domain: this.domain,
                language: this.language,
                email: this.email,
                password: this.password,
                visitor_id: this.visitor_id,
            })
                .then(({data}) => {
                    window.location.href = data.hash_login_url;

                    // this.hash_login_url = data.hash_login_url
                    // this.portal_url = data.portal_url
                    // this.progress = 100
                    // this.loading = false
                    //
                    // this.gotoFinish()
                    this.popNotification('Created', 'success')
                })
                .catch(error => {
                    this.isFormOpen = true;
                    this.loading = false

                    // handle authentication and validation errors here
                    console.log(error.response)
                    this.popNotification('Could not signup', 'danger')
                })
        },
        generateDomain() {
            this.domain = this.nameSlug;
        },
        slugify(text) {
            return text.toString().toLowerCase()
                .replace(/\s+/g, '-')           // Replace spaces with -
                .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
                .replace(/\-\-+/g, '-')         // Replace multiple - with single -
                .replace(/^-+/, '')             // Trim - from start of text
                .replace(/-+$/, '');            // Trim - from end of text
        }


    }
}
</script>